import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import InputError from 'components/CompanySoftCalculator/ui/InputError';
import { InputText } from 'components/InputText';
import Checkbox from 'components/CompanySoftCalculator/ui/Checkbox';
import { InputRadioList } from 'components/InputRadioList';
import { companyKycQuestions } from 'utils/kycData';

import styles from './Kyc.module.scss';

export const Kyc = ({ is_signatory, onIsSignatoryChange, onSubmit, errors, isLoading }: any) => {
  const methods = useForm();
  const [step, setStep] = useState(1);

  const activeStepQuestion = companyKycQuestions[step - 1];
  const activeQuestionValue = methods.watch(activeStepQuestion?.name);

  const lasStep = companyKycQuestions.length + 1;

  const onClickNextStep = useCallback(
    (nextStep?: number) => {
      if (!activeQuestionValue && activeStepQuestion.required) {
        methods.trigger(activeStepQuestion.name);
        return;
      }
      setStep(nextStep || step + 1);
    },
    [activeQuestionValue, activeStepQuestion, methods, step]
  );

  useEffect(() => {
    if (activeStepQuestion?.type === 'radio' && activeQuestionValue) {
      const nextStep = activeStepQuestion.options!.find(
        (option) => option.value === activeQuestionValue
      )?.nextStep;
      setTimeout(() => onClickNextStep(nextStep), 100); // For animation
    }
  }, [activeQuestionValue, onClickNextStep, activeStepQuestion]);

  const getActiveStepElement = () => {
    if (step === lasStep) return null;
    if (activeStepQuestion.type === 'text') {
      return (
        <div key={activeStepQuestion.id} className={styles['question-container']}>
          <label htmlFor={activeStepQuestion.name} className={styles.label}>
            {activeStepQuestion.label}
          </label>
          <InputText
            registerOptions={{ required: activeStepQuestion.required }}
            size="medium"
            label="Ditt svar"
            name={activeStepQuestion.name}
            type="text"
          />
          <button type="button" className={styles.button} onClick={() => onClickNextStep()}>
            Fortsätt
          </button>
        </div>
      );
    }

    if (activeStepQuestion.type === 'radio') {
      return (
        <InputRadioList
          hasErrors={Boolean(methods.formState.errors[activeStepQuestion.name])}
          registerOptions={{ required: activeStepQuestion.required }}
          key={activeStepQuestion.id}
          darkMode
          name={activeStepQuestion.name}
          label={activeStepQuestion.label}
          items={activeStepQuestion.options!}
          size="small"
        />
      );
    }

    return null;
  };

  return isLoading ? (
    <div className={styles.loader}>Loading</div>
  ) : (
    <FormProvider {...methods}>
      <form className={styles['step-four']} onSubmit={methods.handleSubmit(onSubmit)}>
        <span className={styles.headline}>
          Kundkännedomsfrågor {step} av {companyKycQuestions.length + 1}
        </span>
        {getActiveStepElement()}
        {step === lasStep && (
          <>
            <Checkbox
              className="justify-center mb-3"
              label="Jag accepterar villkoren"
              includeLabel
              checked={is_signatory}
              onChange={onIsSignatoryChange}
            />
            <InputError className="mb-3 text-center" text={errors.is_signatory} />
            <button type="submit" className={styles.button}>
              Slutför
            </button>
          </>
        )}
      </form>
      <div className={styles.distance} />
    </FormProvider>
  );
};
